<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('client_report')"/>
        <app-table :id="tableId" :options="options"/>
    </div>
</template>

<script>
import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import { CLIENT_REPORT } from '../../../Config/ApiUrl';
import { numberFormatter } from '../../../Helpers/Helpers';
import { statusTrip } from '../../../Mixins/FilterMixin';

export default {
    name: 'ClientReport',
    extends: CoreLibrary,
    mixins: [statusTrip],
    data() {
        return {
            tableId: 'client-report-table',
            options: {
                name: 'AppClientReport',
                url: CLIENT_REPORT,
                showHeader: true,
                enableSaveFilter: true,
                filters: [
                    {
                        "title": this.$t('Dispatch'),
                        "type": "range-picker",
                        "key": "dispatched_at",
                        "option": ["nothing", "today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t("trip_status"),
                        type: "multi-select-filter",
                        key: "status",
                        option: [],
                        permission: true
                    },
                    {
                        "title": this.$t('exit_date'),
                        "type": "range-picker",
                        "key": "exit_date",
                        "option": ["nothing", "today", "thisMonth", "lastMonth", "thisYear", "lastYear"]
                    },
                ],
                columns: [
                    {
                        title: this.$t('client'),
                        type: 'text',
                        sortable: true,
                        key: 'client',
                    },
                    {
                        title: this.$t('trucks'),
                        type: 'text',
                        sortable: true,
                        key: 'trucks',
                    },
                    {
                        title: this.$t('bundles'),
                        type: 'text',
                        sortable: true,
                        key: 'bundles',
                    },
                    {
                        title: this.$t('net_weight'),
                        type: 'custom-html',
                        sortable: true,
                        key: 'net_weight',
                        modifier: (net_weight) => {
                            return numberFormatter(net_weight);
                        }
                    },
                ],
                showFilter: true,
                showSearch: false,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 8,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    }
}
</script>

<style scoped>

</style>